/**
 * A model for a single Voyage Log.
 * setters, getters, Parses, toJson
 */

var VRC = VRC || {};

VRC.VoyageLogEntry = function (entryData) {
    var _date, _time, _remarks, _mtLoad, _mtOffload, _m2Load, _m2Offload, _event, _port, _lng, _fuel, _id;
    var _subEvent;
    var _inside_500m_zone;
    var _dateTime;
    var _portName;
    var _quayId;
    var _dpMode;

    var init = function (entryData) {
            entryData = entryData || {};
            parse(entryData);
    };

    var getId  = function(){
        return _id;
    };

    var createId = function(){
       var date =  new Date();
       return 'log_' + Math.floor(Math.random()*10000) + '_' + date.getTime();
    };

    var setId = function(id){
        _id = id ? id : createId();
    };

    var setDateTime = function(dateTime){
        _dateTime = dateTime;
    };

    var getDateTime = function(){
        return _dateTime || moment().format(g_timeStampFormat);
    };


    var getRemarks = function(){
        return _remarks;
    };

    var setRemarks = function(remarks){
        _remarks = remarks;
    };

    var setMtLoad = function(mtLoad){
        _mtLoad = mtLoad ? parseFloat(mtLoad) : undefined;
    };

    var getMtLoad = function(){
       return _mtLoad ;
    };

    var setMtOffLoad = function(mtOffLoad){
        _mtOffload = mtOffLoad ? parseFloat(mtOffLoad) : undefined;
    };

    var getMtOffLoad  = function(){
        return _mtOffload;
    };

    var setM2Load = function(m2Load){
        _m2Load = m2Load ? parseFloat(m2Load) : undefined;
    };

    var getM2Load  = function(){
        return _m2Load;
    };

    var setM2OffLoad = function(m2Offload){
        _m2Offload = m2Offload ? parseFloat(m2Offload) : undefined;
    };

    var getBulkLoad  = function(){
        var nextEvent = getNextEvent();
        return VRC.BulkTankManager.getBulkContentSumInDateInterval(g_actions.load, getDateTime(), nextEvent ? nextEvent.getDateTime() : null);
    };
    var getBulkOffload  = function(){
        var nextEvent = getNextEvent();
        return  VRC.BulkTankManager.getBulkContentSumInDateInterval(g_actions.offload, getDateTime(), nextEvent ? nextEvent.getDateTime() : null);
    };

    var getNextEvent = function(){
      return VRC.VoyageLogEntryManager.getNextEvent(getId());
    };

    var getM2OffLoad  = function(){
        return _m2Offload;
    };

    var setEventType = function(event){
      _event =  event ? parseInt(event) : -1;

      // checks to make sure sub event type is set to null if parent is null or doesn't have any active sub events
      if(_event < 0) {
          setSubEventType(-1);
      }
      else if (VRC.MissionTypeService.findActiveSubEventTypes(_event).length === 0) {
          setSubEventType(-1);
      }

    };

    var getEventType = function(){
       return _event;
    };

    var getEventCode = function(){
        return VRC.MasterDataService.getEventCode(getEventType());
    };

    var setSubEventType = function(subEvent) {
        _subEvent = subEvent ? parseInt(subEvent) : -1;
    };

    var getSubEventType = function() {
        return _subEvent;
    };

    var inside500mZone = function() {
        return _inside_500m_zone;
    };

    var setInside500mZone = function(inside500mZone) {
        _inside_500m_zone = inside500mZone;
    };

    var setPort = function(port){

        _port = port ? parseInt(port) : 0;
        if(_port){
            var port = VRC.MasterDataService.getPort(_port);
            if(port){
                _portName = port.name;
            }
        }
    };

    var getPort = function(){
        return _port;
    };



    var getPortName = function(){
        return _portName;
    };

    var getLng = function(){
        return _lng;
    };

    var setLng = function(lng){
        _lng = lng ? parseFloat(lng) : undefined;
    };

    var getFuel = function(){
       return _fuel;
    };
    var setFuel = function(fuel){
        _fuel = fuel ? parseFloat(fuel) : undefined;
    };

    var getQuayId = function () {
        return _quayId;
    };

    var setQuayId = function (quayId) {

        _quayId = quayId;
    };


    var isCargoItem = function(){

        var eventType = getEventType();
        if(!eventType){
            return false;
        }

        var event = VRC.MissionTypeService.getEventTypeById(getEventType()) || {};
        return event.event_type === 'cargo';
    };

    var hasExtraInfo = function(){
        return isCargoItem();
    };

    var hasRequiredExtraInfo = function(){
        return ((getM2Load() || 0) + (getM2OffLoad() || 0) + (getMtLoad() || 0) + (getMtOffLoad() || 0)) > 0;
    };

    var getDpMode = function () {
        return _dpMode;
    };

    var setDpMode = function (dpMode) {
        _dpMode = dpMode === 'yes' || dpMode === 'no' ? dpMode : undefined;  // accept only yes/no values
    };

    var toJson = function(){
      return {
          event : getEventType(),
          subEvent : getSubEventType(),
          id : getId(),
          remarks : getRemarks(),
          m2_load :  getM2Load(),
          m2_offload : getM2OffLoad(),
          bulk_load :  getBulkLoad(),
          bulk_offload : getBulkOffload(),
          mt_load :  getMtLoad(),
          mt_offload : getMtOffLoad(),
          rob_fuel : getFuel(),
          rob_lng : getLng(),
          port : getPort(),
          port_quay_id : getQuayId(),
          portName : getPortName(),
          hasRequiredExtraInfo : hasRequiredExtraInfo(),
          dateTime : getDateTime(),
          inside_500m_zone: inside500mZone(),
          dp_mode: getDpMode()
      }
    };



    var parse = function(inputObject) {

        setEventType(inputObject.event);
        setSubEventType(inputObject.subEvent);
        setId(inputObject.id);
        setPort(inputObject.port);
        setDateTime(inputObject.dateTime);
        setMtLoad(inputObject.mt_load);
        setMtOffLoad(inputObject.mt_offload);
        setM2Load(inputObject.m2_load);
        setM2OffLoad(inputObject.m2_offload);
        setRemarks(inputObject.remarks);
        setFuel(inputObject.rob_fuel);
        setLng(inputObject.rob_lng);
        setQuayId(inputObject.port_quay_id);
        setInside500mZone(inputObject.inside_500m_zone);
        setDpMode(inputObject.dp_mode);
    };

    var isMatch = function(eventType, portId, dateTime){

         if(eventType !== getEventType() || portId !== getPort()){
             return false;
         }

         var thisDateTime = getDateTime();
         if(dateTime && thisDateTime){
             var momentDateTime = moment(dateTime, g_timeStampFormat);
             return moment(thisDateTime, g_timeStampFormat).isSame(momentDateTime);
         }
         else{
             return false;
         }
    };


    init(entryData);

    return {
        setRemarks : setRemarks,
        getRemarks : getRemarks,
        getDateTime : getDateTime,
        setDateTime : setDateTime,
        setMtLoad : setMtLoad,
        getMtLoad : getMtLoad,
        setMtOffload : setMtOffLoad,
        getMtOffload : getMtOffLoad,
        setM2Load : setM2Load,
        getM2Load : getM2Load,
        setM2Offload : setM2OffLoad,
        getM2Offload : getM2OffLoad,
        getBulkLoad : getBulkLoad,
        getBulkOffload : getBulkOffload,
        setFuel : setFuel,
        getFuel : getFuel,
        setLng : setLng,
        getLng : getLng,
        setEventType : setEventType,
        getEventType : getEventType,
        getEventCode : getEventCode,
        setSubEventType : setSubEventType,
        getSubEventType : getSubEventType,
        getPort : getPort,
        setPort : setPort,
        setId : setId,
        getId : getId,
        getQuayId: getQuayId,
        setQuayId: setQuayId,
        toJson : toJson,
        hasExtraInfo : hasExtraInfo,
        isMatch : isMatch,
        setInside500mZone: setInside500mZone,
        getDpMode: getDpMode,
        setDpMode: setDpMode
    };
};
